import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import { thunk } from 'redux-thunk';
import Test_Red from "./reducer/Test_Red";
import Login_Red from "./reducer/loginRed";
import createCampaign_Red from './reducer/createCampaign'
import getCampaign_Red from './reducer/getAllCampaign'
import getCompletedCampaign_Red from './reducer/getCompleteCampaign'
import Reporting_Red from "./reducer/reporting";
import Template_Red from "./reducer/templateMapping/templateMapping";
import User_Red from "./reducer/user/user";
import Role_Red from './reducer/role/roles'
import Transaction_Red from './reducer/transaction/transaction'
import Audit_Red from "./reducer/audit/audit";
import ScreenMaker_Red from './reducer/screenmaker/screenmaker';
import NotificationConfig_Red from "./reducer/notificionConfig/notificationConfig";
import AdConfig_Red from "./reducer/adConfig/adConfig";
import PasswordPolicy_Red from "./reducer/passwordPolicy/passwordPolicy";
import SmtpConfig_Red from "./reducer/smtpConfig/smtpConfig";
import NotifySmtpConfig_Red from "./reducer/smtpConfig/notifySmtpConfig";
import Blacklist_Red from "./reducer/blacklist/blacklist";
import Institution_Red from "./reducer/institution/institution";
import Dashboard_Red from "./reducer/dashboard/dashboard";


const reducers = combineReducers({
  Test_Red,
  Login_Red,
  createCampaign_Red,
  getCampaign_Red,
  getCompletedCampaign_Red,
  Reporting_Red,
  Template_Red,
  User_Red,
  Role_Red,
  Transaction_Red,
  Audit_Red,
  ScreenMaker_Red,
  NotificationConfig_Red,
  AdConfig_Red,
  PasswordPolicy_Red,
  SmtpConfig_Red,
  NotifySmtpConfig_Red,
  Blacklist_Red,
  Institution_Red,
  Dashboard_Red,
});

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, {}, composeEnhancers(applyMiddleware(thunk)));

export default store;
